import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export const useConfirmUnreadMessagesPresenter = (): void => {
  useEffect(() => {
    const group = Entities.GroupsStore.activeGroup;

    if (Entities.App.isFocused && group && !group.withoutMe) {
      let lastUnreadMessage: ChatMessage | null = null;

      Entities.viewportMessages.viewportMessages
        .filter(({ groupId }) => group.id === groupId)
        .forEach(({ messageId }) => {
          const message = group.messagesStore.getMessageById(messageId);

          if (message?.unread && message.serverTime > (lastUnreadMessage?.serverTime || 0)) {
            lastUnreadMessage = message;
          }

          if (lastUnreadMessage) {
            Tasks.messaging.confirmReadMessages({
              groupId: group.id,
              messageId: lastUnreadMessage.id,
            });
          }
        });
    }
  }, [Entities.App.isFocused]);
};
